import React, { FC } from "react";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeProps } from "reactflow";
import { DataType, primitiveTypes } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const resultOutputName = "result";

const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.constantNull,
  label: "Null",
  category: NodeTypeCategory.general,
  controlOutputs: [],
  dataInputs: [],
  dataOutputs: [{ name: resultOutputName, type: DataType.STRING, enabled: true, hideLabel: true }],
  nodeConfigProperties: [
    {
      name: "schema",
      label: "Type",
      propertyType: NodeConfigPropertyType.DataType,
      clearPropertiesOnChange: [schemaProperty],
      options: {
        dataTypes: ([] as DataType[]).concat(primitiveTypes).concat([DataType.OBJECT, DataType.OBJECTREFERENCE]),
        dataProperties: [resultOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: "schema", propertyValues: [DataType.OBJECT] },
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        displayProperty: schemaNameProperty,
        dataProperties: [resultOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Reference",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: "schema", propertyValues: [DataType.OBJECTREFERENCE] },
      options: {
        changeSchemaOnConnection: true,
        referenceOnly: true,
        displayProperty: schemaNameProperty,
        dataProperties: [resultOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    }
  ],
  size: NodeSize.Small,
  evaluate: () => {
    return { output: { result: null as unknown as string }, activeControlHandleIds: [] };
  }
});

export const ConstantNullNode: FC<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
